module.exports = __webpack_public_path__ + "img/miniLogo.7f0bc867.png";